// WELCOME screen — identifier-first onboarding (Truthly-style, adapted for a game):
// one email field routes to Sign In (known) or Create Account (new, with the live
// player-name checkmark). Guest play stays one tap away — play first, register later.
import { CLIENT_VERSION } from '../version';

export const welcomeHTML = /* html */ `
<div id="screenWelcome" class="authscreen hidden">
  <!-- WELCOME CARD — same brand-purple card language as home's .home-card
       (2026-08 restyle). Pure wrapper: every ID and behavioral class inside
       is unchanged; auth.ts wires everything by ID. -->
  <div class="welcome-card">
    <div class="hero">
      <div class="hero-glow" aria-hidden="true"></div>
      <!-- Brother Theo's headshot in the crest medallion (Eric 2026-08-21: "replace
           the cross with Brother Theo"). The ✝ stays as the fallback glyph under
           the image, so a missing asset still shows the original crest. -->
      <div class="crest crest-theo" aria-hidden="true"><span class="crest-glyph">✝</span><img src="media/characters/theo-headshot.png" alt="" /></div>
      <div class="title"><span class="app">Catholics.app</span></div>
      <div class="subtitle">Trivia</div>
      <div class="tagline">Beat the clock. Bank your faith.</div>
    </div>
    <div id="welcomeOffline" class="offline-banner hidden"></div>
    <form class="auth-form" id="welcomeForm" novalidate>
      <div class="field">
        <input type="email" id="welcomeEmail" name="email" placeholder="name@example.com"
               autocomplete="email" inputmode="email" aria-label="Email" />
      </div>
      <div class="auth-msg" id="welcomeMsg"></div>
      <button class="btn" type="submit" id="welcomeContinue">Continue</button>
    </form>
    <div class="or-divider" aria-hidden="true"><span>or</span></div>
    <div class="cta" style="margin-top:0;">
      <button class="btn secondary apple-btn hidden" type="button" id="appleBtn"> Continue with Apple</button>
      <button class="btn secondary" type="button" id="guestBtn">Play as Guest</button>
    </div>
  </div>
  <div class="tos-note">By continuing, you agree to our <a href="terms.html" target="_blank" rel="noopener">Terms of Service</a> and <a href="privacy.html" target="_blank" rel="noopener">Privacy Policy</a>.</div>
  <div class="build-tag">v${CLIENT_VERSION}</div>
</div>`;
